"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const material_1 = require("@mui/material");
const icons_material_1 = require("@mui/icons-material");
const i18n_js_1 = __importDefault(require("i18n-js"));
const styled_components_1 = __importDefault(require("styled-components"));
const react_uid_1 = require("react-uid");
const MAX_UNIT_QUANTITY = 10;
const MultiUnitSelectWrapper = styled_components_1.default.div ``;
const FieldValidationError = styled_components_1.default.div `
  color: red;
  font-style: italic;
  div::first-letter {
    text-transform: uppercase;
  }
`;
const MultiUnitSelectAction = styled_components_1.default.div `
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  margin-top: 25px;
  margin-bottom: 17px;
`;
const MultiUnitSelectLabel = styled_components_1.default.div `
  color: #000000;
  font-weight: 600;
  font-size: 18px;
`;
const Transition = react_1.default.forwardRef((props, ref) => {
    return react_1.default.createElement(material_1.Slide, Object.assign({ direction: "up", ref: ref }, props));
});
const MultiUnitSelect = (props) => {
    const { fieldData, onChange } = props;
    const [units, setUnits] = (0, react_1.useState)([]);
    const [selectedUnits, setSelectedUnits] = (0, react_1.useState)([]);
    const [showUnitOptionsDialog, setShowUnitOptionsDialog] = (0, react_1.useState)(false);
    const handleUnitSelect = activatedIndex => {
        setSelectedUnits(prevUnits => {
            const updatedUnits = prevUnits.map((unit, index) => index === activatedIndex ? Object.assign(Object.assign({}, unit), { selected: !unit.selected }) : unit);
            return updatedUnits;
        });
    };
    const handleUnitQuantityChange = (activatedIndex, increment) => {
        setUnits(prevUnits => {
            const updatedUnits = prevUnits.map((unit, index) => {
                if (index === activatedIndex) {
                    const newQuantity = Math.max(1, Math.min(MAX_UNIT_QUANTITY, (unit.quantity || 1) + increment));
                    return Object.assign(Object.assign({}, unit), { quantity: newQuantity });
                }
                return unit;
            });
            onChange(Object.assign(fieldData, { options: updatedUnits }));
            return updatedUnits;
        });
    };
    const handleUnitDelete = activatedIndex => {
        setUnits(prevUnits => {
            const updatedUnits = prevUnits.map((unit, index) => index === activatedIndex ? Object.assign(Object.assign({}, unit), { selected: false, quantity: 1 }) : unit);
            onChange(Object.assign(fieldData, { options: updatedUnits }));
            return updatedUnits;
        });
    };
    const renderMultiSelectDialog = () => selectedUnits.map((unit, index) => (react_1.default.createElement("div", { key: (0, react_uid_1.uid)(unit) },
        react_1.default.createElement(material_1.ListItem, { secondaryAction: react_1.default.createElement(material_1.Checkbox, { edge: "end", onChange: () => handleUnitSelect(index), checked: unit.selected, inputProps: { 'aria-labelledby': unit.label } }), disablePadding: true },
            react_1.default.createElement(material_1.ListItemButton, { onClick: () => handleUnitSelect(index) },
                react_1.default.createElement(material_1.ListItemText, { id: unit.label, primary: unit.label }))),
        index < selectedUnits.length - 1 && react_1.default.createElement(material_1.Divider, null))));
    const renderSelectedUnitList = () => {
        const selectedUnit = units.filter(unit => unit.selected);
        return (react_1.default.createElement(material_1.List, { disablePadding: true }, selectedUnit.map((unit, index) => (react_1.default.createElement(react_1.default.Fragment, { key: (0, react_uid_1.uid)(unit) },
            react_1.default.createElement(material_1.ListItem, null,
                react_1.default.createElement(material_1.ListItemText, { primary: unit.label }),
                (unit.quantity || 1) > 1 ? (react_1.default.createElement(material_1.IconButton, { onClick: () => handleUnitQuantityChange(units.indexOf(unit), -1) },
                    react_1.default.createElement(icons_material_1.Remove, null))) : (react_1.default.createElement(material_1.IconButton, { onClick: () => handleUnitDelete(units.indexOf(unit)) },
                    react_1.default.createElement(icons_material_1.Delete, null))),
                react_1.default.createElement("span", null, unit.quantity || 1),
                react_1.default.createElement(material_1.Tooltip, { title: (unit.quantity || 1) >= MAX_UNIT_QUANTITY ? 'Maximum quantity reached' : '' },
                    react_1.default.createElement("span", null,
                        react_1.default.createElement(material_1.IconButton, { onClick: () => handleUnitQuantityChange(units.indexOf(unit), 1), disabled: (unit.quantity || 1) >= MAX_UNIT_QUANTITY },
                            react_1.default.createElement(icons_material_1.Add, null))))),
            index < selectedUnit.length - 1 && react_1.default.createElement(material_1.Divider, null))))));
    };
    const openUnitOptionDialog = () => {
        setSelectedUnits(JSON.parse(JSON.stringify(fieldData.options)));
        setShowUnitOptionsDialog(true);
    };
    const handleUnitDialogButtonClick = (action = '') => {
        if (action === 'dismiss') {
            setShowUnitOptionsDialog(false);
        }
        else {
            setUnits(selectedUnits);
            onChange(Object.assign(fieldData, { options: selectedUnits }));
            setShowUnitOptionsDialog(false);
        }
    };
    (0, react_1.useEffect)(() => {
        setUnits(JSON.parse(JSON.stringify(props.fieldData.options)));
    }, [props.fieldData.options]);
    return (react_1.default.createElement(MultiUnitSelectWrapper, { className: fieldData.errors && fieldData.errors.length > 0 ? 'field-error' : '' },
        react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement(MultiUnitSelectAction, null,
                react_1.default.createElement(MultiUnitSelectLabel, null, fieldData.label),
                react_1.default.createElement(material_1.Button, { onClick: openUnitOptionDialog, size: "large", startIcon: react_1.default.createElement(icons_material_1.Add, null), sx: { paddingRight: 5, paddingLeft: 5, border: 1 } }, fieldData.placeholder)),
            react_1.default.createElement(material_1.Grid, { item: true, xs: 12 }, renderSelectedUnitList()),
            react_1.default.createElement(material_1.Dialog, { open: showUnitOptionsDialog, TransitionComponent: Transition, keepMounted: true, onClose: () => handleUnitDialogButtonClick('dismiss'), "aria-describedby": "alert-dialog-slide-description" },
                react_1.default.createElement(material_1.DialogTitle, null, fieldData.label),
                react_1.default.createElement(material_1.DialogContent, null,
                    react_1.default.createElement(material_1.Grid, { item: true, xs: 12 }, selectedUnits.length > 0 && react_1.default.createElement(material_1.List, { sx: { minWidth: 300 } }, renderMultiSelectDialog()))),
                react_1.default.createElement(material_1.DialogActions, null,
                    react_1.default.createElement(material_1.Button, { onClick: e => {
                            e.preventDefault();
                            handleUnitDialogButtonClick('dismiss');
                        } }, i18n_js_1.default.t('cancel')),
                    react_1.default.createElement(material_1.Button, { onClick: e => {
                            e.preventDefault();
                            handleUnitDialogButtonClick();
                        } }, "Ok")))),
        react_1.default.createElement(material_1.Grid, { item: true, xs: 12 },
            react_1.default.createElement(FieldValidationError, null, fieldData.errors ? fieldData.errors.map(error => react_1.default.createElement("div", { key: (0, react_uid_1.uid)(error) }, error)) : react_1.default.createElement(react_1.default.Fragment, null)))));
};
exports.default = MultiUnitSelect;
